import React from 'react';
import { FiCheck, FiMinus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SectionHeader from './ui/SectionHeader';
import { comparisonData } from '../data/products';

export default function Comparison() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader title="Why TerraSip?" subtitle="The Difference" />
        
        <div className="overflow-hidden rounded-3xl border border-stone-200">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-stone-50">
                <th className="p-6 text-sm font-bold uppercase tracking-wider text-stone-400">Features</th>
                <th className="p-6 text-sm font-bold uppercase tracking-wider text-teal-800">TerraSip</th>
                <th className="p-6 text-sm font-bold uppercase tracking-wider text-stone-400">Standard Bottles</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {comparisonData.map((row, idx) => (
                <tr key={idx} className="hover:bg-stone-50/50 transition-colors">
                  <td className="p-6 text-sm font-medium text-stone-900">{row.feature}</td>
                  <td className="p-6 text-sm text-stone-600 font-semibold">{row.terra}</td>
                  <td className="p-6 text-sm text-stone-400">{row.standard}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        <div className="mt-12 p-8 bg-teal-50 rounded-2xl flex flex-col md:flex-row items-center gap-6">
          <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center shrink-0">
            <SafeIcon icon={FiCheck} className="text-teal-700 text-xl" />
          </div>
          <div>
            <h4 className="font-bold text-teal-900 mb-1">Lifetime Technical Warranty</h4>
            <p className="text-teal-700/80 text-sm">We provide replacement parts for the life of your product. Repair, don't replace.</p>
          </div>
        </div>
      </div>
    </section>
  );
}